import i18nFactory from '@yandex-int/i18n';
import moment from 'moment';

import { RadioButtonValue } from '../../components/RadioButtonGroup/RadioButtonGroup';
import { GdCampaignType } from '../../typings/graphql-grid';
import { TernaryControlOwnValue } from '../../typings/internalGroups';

import * as keyset from './InternalGroupHelpers.i18n';

const i18n = i18nFactory(keyset);

export const importValueForShowDates = (tags: string[]): string[] => {
    return tags.map(tag => moment(tag, 'YYYY-MM-DD').format('DD.MM.YYYY'));
};

export const exportValueForShowDates = (tags: string[]): string[] => {
    return tags.map(tag => moment(tag, 'DD.MM.YYYY').format('YYYY-MM-DD'));
};

export const mapShowDatesOnSave = (value: string[][]): string[][] => {
    return value
        .filter(it => it.join(' ') !== 'Invalid date')
        .sort((a, b) => moment(a.join(' ')).diff(moment(b.join(' '))));
};

export const isInternalGroup = (type: GdCampaignType): boolean => {
    return (
        type === GdCampaignType.INTERNAL_FREE ||
        type === GdCampaignType.INTERNAL_DISTRIB
    );
};

export const getRadioTargetingItems = (): RadioButtonValue[] => {
    return [
        {
            id: TernaryControlOwnValue.YES,
            name: i18n('yes')
        },
        {
            id: TernaryControlOwnValue.NO,
            name: i18n('no')
        },
        {
            id: TernaryControlOwnValue.NOT_SELECTED,
            name: i18n('not-selected')
        }
    ];
};

export const getValueForToggle = (
    toggleId: string,
    includedValue: string[],
    excludedValue: string[]
): TernaryControlOwnValue => {
    if (includedValue.includes(toggleId)) {
        return TernaryControlOwnValue.YES;
    }

    if (excludedValue.includes(toggleId)) {
        return TernaryControlOwnValue.NO;
    }

    return TernaryControlOwnValue.NOT_SELECTED;
};

export const getRadioButtonGroupKey = (
    groupValue: string,
    toggleId: string,
    includedValue: string[],
    excludedValue: string[]
): string => {
    return `${toggleId}_${groupValue}_${includedValue.length}_${
        excludedValue.length
    }`;
};
